(() => {
  if (window.ivPaymentOptionsV22) return;
  window.ivPaymentOptionsV22 = true;
  // The official placement does not prepend "Or" for every offer/locale.
  // Label the optional financing independently, without changing provider text.
  const watched = new WeakSet();
  function labelFinancing() {
    document.querySelectorAll('.product-information klarna-placement').forEach(placement => {
      if (watched.has(placement) || !placement.shadowRoot) return;
      watched.add(placement);
      const label = document.createElement('span');
      label.className = 'iv-payment-options__financing-label';
      label.textContent = 'Optional installments';
      label.hidden = true;
      placement.before(label);
      const update = () => {
        label.hidden = !placement.shadowRoot.querySelector('[part="osm-message"]')?.textContent.trim();
      };
      const observer = new MutationObserver(update);
      observer.observe(placement.shadowRoot, {subtree: true, childList: true, characterData: true});
      update();
    });
  }
  labelFinancing();
  customElements.whenDefined('klarna-placement').then(labelFinancing);
  new MutationObserver(labelFinancing).observe(document.body, {subtree: true, childList: true});
  document.addEventListener('keydown', (event) => {
    const dialog = event.target.closest('[data-iv-payment-dialog][open]');
    if (!dialog || event.key !== 'Tab') return;
    const elements = [...dialog.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]')].filter(n => n.getClientRects().length);
    const first = elements[0], last = elements[elements.length - 1];
    if ((!event.shiftKey && document.activeElement === last) || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault();
      (event.shiftKey ? last : first)?.focus();
    }
  });
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-iv-payment-open]');
    if (open) {
      const dialog = open.closest('[data-iv-payment-options]')?.querySelector('[data-iv-payment-dialog]');
      if (dialog && !dialog.open) {
        dialog.showModal();
        dialog.addEventListener('close', () => { if (open.isConnected) open.focus({preventScroll: true}); }, {once: true});
      }
      return;
    }
    const close = event.target.closest('[data-iv-payment-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('[data-iv-payment-dialog]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
